<template>
  <button class="button" @click="clickHandler" v-if="!hideCloseButton">
    <icon type="close" :color="color" :size="16" class="">
    </icon>
  </button>
</template>

<script>
import { mapState } from 'redux-vuex';
import { Icon } from '@/components/shared-components';
import select from '@/store/selectors';
import store from '@/store';
import { requestPause } from '@/store/actions/play';
import { PLAYER_CLOSE } from '@/utils/messages';
import { getForegroundColor } from '@/utils/color';

export default {
  components: {
    Icon,
  },
  data: mapState({
    hideCloseButton: select.customOptions.hideCloseButton,
    playerId: select.playerId,
    darkMode: select.customOptions.darkMode,
  }),
  methods: {
    clickHandler() {
      store.dispatch(requestPause());
      window.parent.postMessage({
        type: PLAYER_CLOSE,
        data: {
          playerId: this.playerId,
        },
      }, '*');
    },
  },
  computed: {
    color() {
      return getForegroundColor(this.darkMode);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/scss/boot';
  @import '~@/assets/scss/resets';

  .button {
    @extend %button;
  }
</style>
